import React from 'react';
import Dialog from 'material-ui/Dialog';
import { FlatButton, List, ListItem, RaisedButton } from 'material-ui';
import FileDownload from 'material-ui/svg-icons/file/file-download';


class Attachments extends React.Component {
    render() {
        const { 
            attachments,
            toggleAttachmentsDialog, 
            openedAttachmentsDialog, 
            buttonStyle,
            labelStyle,
            style,
        } = this.props;

        const actions = [
            <FlatButton
                label='CLOSE'
                primary
                onClick={toggleAttachmentsDialog}
            />,
        ];

        return (
            <div className='btn'>
                <Dialog 
                    open={openedAttachmentsDialog}
                    title='Attachments'
                    actions={actions}
                    onRequestClose={toggleAttachmentsDialog}
                    bodyStyle={{
                        overflowY: 'scroll',
                        minHeight: '53vh',
                    }}
                >
                    <List>
                        {
                            attachments && attachments.map((attachment) => {
                                const url = `/api/v1/file/${attachment.fileId}`;
                                return (
                                    <a key={attachment._id} style={{ textDecoration: 'none' }} href={url} download>
                                        <ListItem 
                                            key={attachment._id} 
                                            primaryText={attachment.name} 
                                            leftIcon={<FileDownload />}
                                        />
                                    </a>
                                );
                            })
                        }
                    </List>
                </Dialog>

                <RaisedButton 
                    onClick={toggleAttachmentsDialog}
                    label='Attachments'
                    className='btn'
                    buttonStyle={buttonStyle}
                    labelStyle={labelStyle}
                    style={style}
                    primary
                    disabled={attachments && !attachments.length}
                />

            </div>
        );
    }
}

export default Attachments;



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Attachments.jsx